import { Component, Input, PLATFORM_ID, inject } from '@angular/core';
import { ImageSliderComponent } from '../image-slider/image-slider.component';
import { ImageModel } from '../../../model/image.model';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sustainability-platform',
  imports: [TranslateModule, ImageSliderComponent],
  templateUrl: './sustainability-platform.component.html',
  styleUrl: './sustainability-platform.component.scss',
})
export class SustainabilityPlatformComponent {
  @Input() list: ImageModel[] = [];

  constructor() {}

  ngOnInit(): void {}
}
